import { render, staticRenderFns } from "./q13.vue?vue&type=template&id=072c78a8&scoped=true&"
import script from "./q13.vue?vue&type=script&lang=js&"
export * from "./q13.vue?vue&type=script&lang=js&"
import style0 from "./q13.vue?vue&type=style&index=0&id=072c78a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c78a8",
  null
  
)

export default component.exports